type Variant = "empty" | "error" | "loading";

const VARIANT_STYLES: Record<Variant, string> = {
  empty: "border-slate-800 bg-slate-900/40 text-slate-400",
  error: "border-rose-900/60 bg-rose-950/20 text-rose-200",
  loading: "border-slate-800 bg-slate-900/40 text-slate-500",
};

const ICONS: Record<Variant, React.ReactNode> = {
  empty: (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 12h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  error: (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
      <path
        d="M12 9v4m0 3.5v.01M5 19h14a1.5 1.5 0 0 0 1.31-2.24l-7-12.5a1.5 1.5 0 0 0-2.62 0l-7 12.5A1.5 1.5 0 0 0 5 19Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  loading: (
    <svg viewBox="0 0 20 20" fill="none" className="h-5 w-5 animate-spin" aria-hidden="true">
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2" />
      <path d="M17 10a7 7 0 0 0-7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
};

export default function EmptyState({
  variant = "empty",
  title,
  hint,
  action,
  className,
}: {
  variant?: Variant;
  title: string;
  hint?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`rounded-2xl border px-4 py-10 text-center ${VARIANT_STYLES[variant]} ${className ?? ""}`}
      role={variant === "error" ? "alert" : undefined}
    >
      <div className="mb-2 inline-flex items-center justify-center opacity-70">
        {ICONS[variant]}
      </div>
      <div className="text-sm font-medium">{title}</div>
      {hint ? <div className="mt-1 text-xs opacity-80">{hint}</div> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
